import React from "react";
import { IMaskInput } from "react-imask";
import { IPinSchema } from "../../../interfaces/IPin";
import * as yup from "yup";
import { TipoPinEnum } from "../../../interfaces/Enums";
interface CustomProps {
  onChange: (event: { target: { name: string; value: string; tipoPin: TipoPinEnum } }) => void;
  name: string;
}

export const defaultValuesPinInactive: IPinSchema = {
  numeroPin: "",
  tipoPin: TipoPinEnum.TeamChoice,
};

export const pinInactiveSchema = yup.object({
  numeroPin: yup
    .string()
    .required("*Campo Obrigatório"),
  tipoPin: yup.number().required("*Campo Obrigatório"),
});

export const PinMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function PinMaskCustom(props, ref) {
    const { onChange, name, ...other } = props;

    const handleAccept = (value: string) => {
      // Determine tipoPin based on the length of numeroPin
      let tipoPin: TipoPinEnum = TipoPinEnum.Bhn; // Default value

      if (value.length === 19) {
        tipoPin = TipoPinEnum.Epay;
      }
      onChange({ target: { name, value, tipoPin } });
    };

    return (
      <IMaskInput
        {...other}
        mask="####-####-####-####"
        definitions={{
          "#": /[a-zA-Z0-9]/,
        }}
        inputRef={ref}
        onAccept={handleAccept}
        overwrite
      />
    );
  }
);